import { useEffect, useState } from 'react';
import { useOcSelector } from '../redux/ocStore';
import { defaultBuyer, localStorageKeys } from '../helpers/Constants';

export type UserPetsType = {
  [key: string]: string[];
};

/**
 * Custom hook to manage user pets data
 * @returns Object containing user pets data and availability status
 */
const useUserPets = () => {
  const userDetails = useOcSelector((state) => state?.ocUser?.user);
  const isAnonymous = useOcSelector((state) => state?.ocAuth?.isAnonymous);
  const [userPets, setUserPets] = useState<UserPetsType>({});
  const isUserPetsAvailable = userPets && Object.keys(userPets).length > 0;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const petsFromLocalStorage = localStorage?.getItem(localStorageKeys?.myPets);
      const petsFromUserDetails = userDetails?.xp?.Pets;

      if (petsFromLocalStorage) {
        try {
          setUserPets(JSON.parse(petsFromLocalStorage));
        } catch (e) {
          console.error('Error parsing pets from localStorage:', e);
        }
      } else if (petsFromUserDetails) {
        setUserPets(petsFromUserDetails);
      }

      // Reset pets data if user is default buyer
      if (userDetails?.ID === defaultBuyer?.ID || isAnonymous) {
        setUserPets({});
      }
    }
  }, [userDetails?.xp?.Pets, userDetails?.ID, isAnonymous]);

  return {
    userPets,
    isUserPetsAvailable,
  };
};

export default useUserPets;
